<template>
  <!--<el-card shadow="never" class="aui-card&#45;&#45;fill">-->
  <div class="pkg-search-box">
    <el-form class="pkg-content" :model="dataForm" ref="dataForm">
      <div class="location-layout">
        <el-row :gutter="0">
          <!--车辆底盘号-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.chassisNo')" prop="chassisNo">
              <el-input readonly maxlength="50"  disabled="true" v-model="dataForm.chassisNo"></el-input>
            </el-form-item>
          </el-col>
          <!--车型分类-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.vehicleClassId')" prop="vehicleClassId">
              <el-input readonly disabled="true" v-model="dataForm.showValue"></el-input>
            </el-form-item>
          </el-col>
          <!--研发代码:-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.rdCodeId')" prop="rdCodeId">
              <el-input readonly disabled="true" v-model="dataForm.rdCodeName" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--品牌:-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.brandId')" prop="brandId">
              <el-input readonly disabled="true" v-model="dataForm.brandName" ></el-input>
            </el-form-item>
          </el-col>
          <!--所属公司-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.companyId')" prop="companyCnName">
              <el-input readonly disabled="true" v-model="dataForm.companyCnName"></el-input>
            </el-form-item>
          </el-col>
          <!--所属场地-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.subordinateSiteId')" prop="subordinateSiteId">
              <el-input v-model="dataForm.subordinateSiteName"
                        disabled="true"
                        readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--车辆分类-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.vehicleClassification')" prop="vehicleClassification">
              <el-select v-model="dataForm.vehicleClassification" :disabled="true">
                <el-option v-for="(item,index) in vehicleClassArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--车辆状态-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.status')" prop="status">
              <el-select v-model="dataForm.status" :disabled="true">
                <el-option
                  v-for="(item,index) in statusArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--生产日期-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.productionDate')" prop="productionDate">
              <el-input
                readonly
                disabled="true"
                v-model="dataForm.productionDate">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--开始时间-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.startTime')" prop="startTime">
              <el-input readonly
                        disabled="true"
                v-model="dataForm.startTime">
              </el-input>
            </el-form-item>
          </el-col>
          <!--结束时间-->
          <el-col :span="7">
            <el-form-item  prop="endTime">
                  {{$t('res.vehinfo.endTime')}}
                  <el-tooltip placement="top-start" effect="light" >
                    <div slot="content">
                      结束日期当日可用。
                    </div>
                    <em class="el-icon-question" style="color: #1C69D3"></em>
                  </el-tooltip>
              <el-input readonly
                        disabled="true"
                v-model="dataForm.endTime">
              </el-input>
            </el-form-item>
          </el-col>
          <!--是否计算利用率-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.ifCount')" prop="ifCount">
              <el-select v-model="dataForm.ifCount" :disabled="true">
                <el-option
                  v-for="(item,index) in ifCountList"
                  :key="index"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--发动机型号-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.engineModel')" prop="engineModel">
              <el-input disabled="true" v-model="dataForm.engineModel" readonly></el-input>
            </el-form-item>
          </el-col>
          <!--备注-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.remark')" prop="remark">
              <el-input readonly disabled="true" v-model="dataForm.remark"></el-input>
            </el-form-item>
          </el-col>
          <!--上传车辆配置详细信息文件-->
          <el-col :span="6">
            <el-form-item prop="isUpload">
              <!--<upload-file v-bind:fileList="fileList"-->
                           <!--v-bind:beforeRemove="uploadBeforeRemove"-->
                           <!--v-bind:uploadSuccess="submitUploadSuccess"></upload-file>-->
            </el-form-item>
            <!--<span v-if="dataForm.fileName !== '' || dataForm.fileName" style="font-weight: bold;">{{dataForm.fileName}}</span>-->
            <div style="text-align: left;font-size: 12px;color: darkgray;">{{'车辆配置信息文件(不超过4M，上传格式为jpg/png/xlsx/xls/zip/rar/txt/pdf文件)'}}</div>
            <el-button v-if="dataForm.fileName !== '' || dataForm.fileName"
                       size="mini"
                       @click="downloadFile"
                       type="text">{{dataForm.fileName}}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <br>
    <br>
    <div class="pkg-content">
      <h3>{{ $t('res.cri.tag') }}</h3>
      <el-form label-position="top"
               label-width="145px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow = "false"
                     :closeShow = "false"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <br>
    <br>
    <div class="pkg-content">
      <!--<h3>{{ $t('res.cri.yearTargetList') }}</h3>-->
      <el-row>
        <el-col :span="24"
                style="line-height: 34px;">
          <div>
            <div class="label-title">{{ $t('res.cri.yearTargetList') }}</div>
          </div>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="24">
          <el-table :data="targetTableData"
                    height="250"
                    border
                    stripe
                    style="width: 100%">
            <!-- 年份 -->
            <el-table-column prop="annual"
                             align="center"
                             :label="$t('res.cri.year')"
                             min-width="180">
              <template slot-scope="scope">
                <el-input v-if="isEditTableObj['keyId-' + scope.row.id]" size="mini" v-model="scope.row.annual" ></el-input>
                <span v-else>{{scope.row.annual}}</span>
              </template>
            </el-table-column>
            <!-- 报表年度目标 -->
            <el-table-column prop="reportAnnualTarget"
                             align="center"
                             :label="$t('res.cri.yearTarget')"
                             min-width="180">
              <template slot-scope="scope">
                <el-input v-if="isEditTableObj['keyId-' + scope.row.id]" size="mini" v-model="scope.row.reportAnnualTarget" ></el-input>
                <span v-else>{{scope.row.reportAnnualTarget}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <br>
    <div class="pkg-content">
      <div class="btn-position-up"
         style="text-align:right;">
      <el-button type="primary" v-if="$hasPermission('AUTHVEHICLE0010')" @click="editVehicleInfo()">{{ $t('res.vehinfo.edit') }}</el-button>
      <!--返回按钮-->
      <el-button type="info" @click="backPage()">{{ $t('res.vehinfo.back') }}</el-button>
    </div>
    </div>
  </div>
</template>

<script>
import ClassTree from '@/components/rm/class-tree/index'
import subordinateSite from '@/components/rm/subordinate-site/index'
import UploadFile from '@/components/rm/upload-file/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'

export default {
  components: {
    Tag,
    'class-tree': ClassTree,
    'subordinate-site': subordinateSite,
    'upload-file': UploadFile
  },
  data () {
    let _this = this
    return {
      statusArr: _this.enums['status'], // 状态
      ifCountList: _this.enums['confirmState'], // 是否利用计算率
      vehicleClassArr: _this.enums['vehicleClass'], // 车辆分类
      dataListLoading: false,
      visible: false,
      // 上传的文件
      fileList: [],
      // 是否显示所属场地
      isShowSuboSite: false,
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 16,
      bussinessTypeChecked: 16,
      isEditTableObj: {},
      // 车型分类树
      defaultProps: {
        children: 'children',
        label: 'classCnName'
      },
      queryTreeUrl: '/rm/vehicleclass/list',
      // 操作类型 新增/修改
      operationType: '',
      dataForm: {
        showVehicleClassList: [],
        showValue: '',
        id: 0,
        chassisNo: '',
        vehicleClassId: '',
        rdCodeId: '',
        rdCodeName: '',
        brandId: '',
        brandName: '',
        companyId: '',
        companyCnName: '',
        subordinateSiteId: '',
        subordinateSiteName: '',
        presentSiteId: '',
        presentSiteName: '',
        addPresentSiteId: '',
        addPresentSiteName: '',
        vehicleClassification: '',
        status: '',
        productionDate: '',
        startTime: '',
        endTime: '',
        ifCount: '',
        engineModel: '',
        isUpload: '',
        creator: '',
        createdDate: '',
        modifier: '',
        lastUpdatedDate: '',
        remark: '',
        version: '',
        // 文件上传信息
        fileUpload: undefined,
        // 文件名称
        fileName: '',
        // 文件id
        fileId: ''
      },
      // 年度目标列表数据
      targetTableData: [],
      // 保存和编辑按钮的切换开关
      saveBtn: false,
      //  类型（新增或删除）
      type: '',
      isAddForm: false
    }
  },
  mounted () {
    this.initMethod()
    this.$eventHub.$on(this.GLOBAL.VEHICLE_INFO, (data) => {
      this.initMethod()
    })
  },
  methods: {
    // 页面打开初始化方法
    initMethod () {
      // 清空表单校验
      this.$nextTick(() => {
        // this.$refs['dataForm'].resetFields()
        if (this.$route.query.id !== undefined) {
          this.dataForm.id = this.$route.query.id
          this.type = this.$route.query.type
          this.operationType = this.$route.query.operationType
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$request.get(`/rm/vehicleinfo/info/${this.dataForm.id}`).then((data) => {
        console.info(data)
        this.dataForm.id = data.id
        this.dataForm.chassisNo = data.chassisNo
        this.dataForm.vehicleClassId = data.vehicleClassId
        this.dataForm.rdCodeId = data.rdCodeId
        this.dataForm.rdCodeName = data.rdCodeName
        this.dataForm.brandId = data.brandId
        this.dataForm.brandName = data.brandName
        this.dataForm.companyId = data.companyId
        this.dataForm.companyCnName = data.companyCnName
        this.dataForm.subordinateSiteId = data.subordinateSiteId
        this.dataForm.subordinateSiteName = data.siteCnName
        this.dataForm.presentSiteId = data.presentSiteId
        this.dataForm.presentSiteName = data.presentSiteName
        this.dataForm.vehicleClassification = data.vehicleClassification
        this.dataForm.status = data.status
        this.dataForm.fileName = data.fileName
        this.dataForm.fileId = data.fileId
        if (data.productionDate) {
          this.dataForm.productionDate = data.productionDate.substring(0, 10)
        } else {
          this.dataForm.productionDate = data.productionDate
        }
        if (data.startTime) {
          this.dataForm.startTime = data.startTime.substring(0, 10)
        } else {
          this.dataForm.startTime = data.startTime
        }
        if (data.endTime) {
          this.dataForm.endTime = data.endTime.substring(0, 10)
        } else {
          this.dataForm.endTime = data.endTime
        }
        this.dataForm.ifCount = data.ifCount
        this.dataForm.engineModel = data.engineModel
        this.dataForm.isUpload = data.isUpload
        this.dataForm.creator = data.creator
        this.dataForm.createdDate = data.createdDate
        this.dataForm.modifier = data.modifier
        this.dataForm.remark = data.remark
        this.dataForm.lastUpdatedDate = data.lastUpdatedDate
        this.dataForm.version = data.version
        this.targetTableData = data.targetList
        // 车型分类的回填
        this.dataForm.showValue = data.classCnName
        this.dataForm.showSiteClassList = []
        this.dataForm.showSiteClassList.push(data.vehicleClassId)
        // 已选择的标签
        this.checkList = data.commLabelVoList ? data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameCn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameCn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameCn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameEn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameEn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameEn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        }
      })
    },
    backPage () {
      this.$router.go(-1)
    },
    getSelectList (args) {
      this.dataForm.vehicleClassId = args[0]
    },
    // 编辑跳转按钮
    editVehicleInfo () {
      let _this = this
      // _this.$confirm(_this.$t('trainer.cancelinfo'), _this.$t('prompt.title'), {
      //   confirmButtonText: _this.$t('confirm'),
      //   cancelButtonText: _this.$t('cancel'),
      //   type: 'warning'
      // }).then(() => {
        _this.tabRemove()
        let query = {}
        let name = 'rm-vehicleinfo-add-or-update'
        query.id = this.dataForm.id
        query.type = 'updata'
        query.operationType = 'update'
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.VEHICLE_INFO, '')
      // })
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = 16
      this.bussinessTypeId = 16
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      this.checkList = []
      // 已选择的标签
      this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameCn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameCn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameCn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      } else {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameEn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameEn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameEn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      }
    },
    // 移除文件
    // uploadBeforeRemove (file, fileList) {
    //   this.fileList = []
    //   this.dataForm.fileUpload = undefined
    //   this.dataForm.fileName = ''
    //   this.dataForm.fileId = ''
    // },
    // 获取文件上的后的文件信息
    // submitUploadSuccess (response, file, fileList) {
    //   if (response && response !== '') {
    //     this.dataForm.fileUpload = response.data
    //     this.dataForm.fileName = response.data.filename
    //     this.dataForm.fileId = response.data.fileId
    //   }
    // },
    // 下载文件
    downloadFile () {
      let requestUrl = window.SITE_CONFIG['apiBaseURL'] + '/rm/file/download' + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`
      let dlform = document.createElement('form')
      dlform.method = 'post'
      dlform.action = requestUrl
      let hdnFilePath = document.createElement('input')
      hdnFilePath.type = 'hidden'
      hdnFilePath.name = 'id'
      hdnFilePath.value = this.dataForm.fileId
      dlform.appendChild(hdnFilePath)
      document.body.appendChild(dlform)
      dlform.submit()
      document.body.removeChild(dlform)
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  }
}
</script>
<style lang="css" scoped>
  /* 模拟部分的el-card样式 */
  .pkg-search-box {
    color: #303133;
    transition: 0.3s;
    border-radius: 4px;
    overflow: hidden;
  }
  .pkg-content {
    background-color: #fff;
    padding: 20px;
  }
  /* icon style */
  .pkg-icon-button {
    display: inline-block;
    padding: 0 20px;
    font-size: 20px;
    color: blue;
    vertical-align: middle;
    cursor: pointer;
  }
  .label-title {
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
  }
  .button-icon {
    display: inline-block;
    float: right;
  }
</style>
